import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './OrganizationDetails.css';
import Sidebar from './sidebar';

const OrganizationDetails = () => {
  const [organizations, setOrganizations] = useState([]);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}v1/organizations`, {
      headers: {
        'x-api-key': '12345xxa'
      }
    })
    .then((res) => {
      setOrganizations(res.data);
    })
    .catch((error) => {
      console.error('Ошибка при получении данных о заказах:', error);
    });
  }, []);

  if (organizations.length === 0) {
    return <div>Loading...</div>;
  }

  return (
    <div className="main-container-organization-details">
      <div className="sidebar-organization-details">
        <Sidebar />
        <ul>
          <li>Пункт 1</li>
          <li>Пункт 2</li>
          <li>Пункт 3</li>
        </ul>
      </div>
      <div className="content-organization-details">
        {organizations.map((organization) => (
          <div className="organization-details" key={organization.id}>
            <div className="organizationdetails-header">
              <h1>{organization.name}</h1>
              <div className="id">
                <span>ID:</span> {organization.id}
              </div>
            </div>
            <div className="additional-info">
              <div>БИН: {organization.bin}</div>
              <div>Адрес: {organization.address}</div>
              <div>Директор: {organization.director}</div>
              <div>Телефон: {organization.phone}</div>
              <div>Почта: {organization.email}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrganizationDetails;
